import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isVisible) = $event)),
    title: "Ecart de trésorerie",
    "valid-title": "Rapprochements bancaires",
    prefixDataCy: "BankReconciliationDiscrepancyDialog",
    onValid: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToReconciliation()))
  }, {
    default: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("p", {
        class: "text-center",
        "data-cy": "BankReconciliationDiscrepancyDialog_ContentMessage"
      }, " Il existe au moins un écart entre le solde de trésorerie et la comptabilité, veuillez accéder aux rapprochements bancaires pour plus de détails ", -1)
    ])),
    _: 1
  }, 8, ["modelValue"]))
}